import { Environment } from "../../../environment";
import { Api, IPaginacao } from "../axios-config";

export interface ISetor {
    idSetor: number,
    nomeSetor: string,
    idUnidade: number,
}

interface TSetor {
    setor: ISetor[];
    paginacao: IPaginacao;
}

const getByIdUnidade = async (idUnidade: number, page=1, estado: boolean): Promise<TSetor | Error> => {
    try {
        const { data } = await Api.get(`Setor/idUnidade?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&idUnidade=${idUnidade}&estado=${estado}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}

const list = async (idUnidade: number): Promise<ISetor[] | Error> => {
    try {
        const { data } = await Api.get(`Setor/idUnidade?idUnidade=${idUnidade}&estado=true&estado=true&listar=true`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}

const getByIdSetor = async (idSetor: number): Promise<ISetor | Error> => {
    try {

        const { data } = await Api.get(`Setor/idSetor?idSetor=${idSetor}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}

const create = async (dados: Omit<ISetor, 'idSetor'>): Promise<number | Error> => {
    try {
        const { data } = await Api.post('Setor', dados);

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
}

const updateById = async (dados: ISetor): Promise<void | Error> => {
    try {
        await Api.put(`Setor`, dados);
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao atualizar o registro');
    }
};

const toggleEstadoById = async (idSetor: number): Promise<void | Error> => {
    try {
        await Api.patch(`Setor/desativar?id=${idSetor}`);
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao atualizar o registro');
    }
};

export const SetorService = {
    getByIdUnidade,
    list,
    getByIdSetor,
    create,
    updateById,
    toggleEstadoById,
}